import {connect} from '@modifi/redux'
import {aShowDialog} from '@modifi/plugin-dialogs'
import TransactionBox from './TransactionBox'
import {aFetchTransaction} from '../../../../data/transaction'

const mapStateToProps = () => ({})

const mapDispatchToProps = {
  showDialog: aShowDialog,
  fetchTransaction: aFetchTransaction,
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionBox)
